module.exports = __webpack_public_path__ + "img/menu-tcby.1e8c4d22.webp";